import styled from 'styled-components';
import whiteWithText from '../../assets/icons/JagadLogoWithTextWhite.svg';
import blackText from '../../assets/icons/JagadLogoWithTextBlack.svg';
import blackWithBlackText from '../../assets/icons/JagadLogoBlackWithTextBlack.svg';
import circular from '../../assets/icons/JagadLogoCircular.svg';

type Props = {
  $widthInPercent?: number;
};

export const JagadLogoWhiteWithText = (styled.img.attrs({
  src: whiteWithText,
})<Props>`
  width: ${({ $widthInPercent }: Props) =>
    $widthInPercent ? `${$widthInPercent}%` : '50%'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const JagadLogoColorWithBlackText = (styled.img.attrs({
  src: blackText,
})<Props>``) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const JagadLogoBlackWithBlackText = (styled.img.attrs({
  src: blackWithBlackText,
})<Props>`
  width: ${({ $widthInPercent }: Props) =>
    $widthInPercent ? `${$widthInPercent}%` : '50%'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const JagadLogoCircular = (styled.img.attrs({
  src: circular,
})<Props>`
  width: ${({ $widthInPercent }: Props) =>
    $widthInPercent ? `${$widthInPercent}%` : '50%'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
